import {
  apiGetWebinar,
  apiGetWebinars,
  apiGetWebinarFilters,
  apiDeleteWebinar,
  apiSaveWebinar,
} from '@/api/marketingModule';

export default {
  namespaced: true,

  state: () => ({
    filters: {
      creator: [],
      status: [],
    },
    selectedFilters: {
      creator: [],
      status: [],
    },
    webinars: [],
    totalItems: 0,
    tableLoading: false,
    currentWebinar: null,
  }),

  mutations: {
    setFilters(state, payload) {
      state.filters.creator = payload.creators || [];
      state.filters.status = payload.statuses || [];
    },

    setSelectedFilters(state, payload) {
      state.selectedFilters.creator = payload.creator || [];
      state.selectedFilters.status = payload.status || [];
    },

    setWebinars(state, payload) {
      state.webinars = payload;
    },

    setTotalItems(state, payload) {
      state.totalItems = payload;
    },

    setTableLoading(state, payload) {
      state.tableLoading = payload;
    },

    setCurrentWebinar(state, payload) {
      state.currentWebinar = payload;
    },

    removeWebinar(state, id) {
      state.webinars = state.webinars.filter((w) => w.id !== id);
    },

    updateWebinarInList(state, updatedWebinar) {
      state.webinars = state.webinars.map(
        (w) => (w.id === updatedWebinar.id ? updatedWebinar : w),
      );
    },
  },

  getters: {
    formattedFilters: (state) => ({
      creator: state.selectedFilters.creator,
      status: state.selectedFilters.status,
    }),
  },

  actions: {
    async getFilters({ commit }) {
      const result = await apiGetWebinarFilters();
      commit('setFilters', result);
    },

    async getWebinars({ commit }, payload) {
      commit('setTableLoading', true);
      const data = {
        ...payload,
        sort_by: payload.sortBy,
        sort_desc: payload.sortDesc,
      };
      const { results, total } = await apiGetWebinars(data);
      commit('setWebinars', results);
      commit('setTotalItems', total);
      commit('setTableLoading', false);
    },

    async getWebinar({ commit }, webinarId) {
      const result = await apiGetWebinar({ id: webinarId });
      if (result && result.id) {
        commit('setCurrentWebinar', result);
      }
    },

    async saveWebinar(_, { payload, thumbnail }) {
      try {
        await apiSaveWebinar(payload, thumbnail);
        this._vm.$snackbar.success('Webinar saved successfully');
      } catch (e) {
        this._vm.$snackbar.error('Could not save webinar');
      }
    },

    async deleteWebinar({ commit }, webinar) {
      try {
        await apiDeleteWebinar({ id: webinar.id });
        commit('removeWebinar', webinar.id);
        this._vm.$snackbar.success(`Webinar "${webinar.title}" was deleted successfully.`);
      } catch (e) {
        this._vm.$snackbar.error('Could not delete webinar');
      }
    },

    clearCurrentWebinar({ commit }) {
      commit('setCurrentWebinar', null);
    },

  },
};
